import { ValidationError } from "yup";

export interface Errors {
  [key: string]: string;
}

export const getValidationErros = (err: ValidationError): Errors => {
  const valdiationErrors: Errors = {};
  err.inner.forEach((error) => {
    if (error?.path) {
      valdiationErrors[error.path] = error.message;
    }
  });
  return valdiationErrors;
};
